import React from 'react'
import { isMobile } from '../../helpers/mobileresize/Mobileresize'
import WebCreateDeal from './web/CreateDeal'
import MobileCreateDeal from './mobile/CreateDeal'

const index = () =>{
    if(isMobile){
        return(
            <div>
                <MobileCreateDeal />
            </div>
        )
    }else{
        return(
            <div>
                <WebCreateDeal />
            </div>
        )
    }
}

export default index